var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsVinNumberDocumentation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dr0bnm7uja",
    d: "M37.895 0c0 1.744-1.413 3.157-3.157 3.157H7.893c-2.61 0-4.736 2.127-4.736 4.74 0 2.61 2.127 4.736 4.736 4.736h30.002V60H6.315C2.83 60 0 57.17 0 53.682V7.897C0 3.597 3.453 0 7.893 0h30.002zM3.157 14.19v39.492c0 1.741 1.417 3.157 3.158 3.157h28.423V15.79H7.893c-1.772 0-3.412-.601-4.736-1.6zm22.106 17.389v3.157H12.63V31.58h12.633zm3.157-6.315v3.154H9.473v-3.154H28.42zm9.475-18.948v3.158H7.894c-.87 0-1.579-.707-1.579-1.579s.71-1.579 1.579-1.579h30.001z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-685 -517) translate(258 288) translate(366 229) translate(61) translate(13 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5z6dezz0nb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dr0bnm7uja"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#00095B",
    xlinkHref: "#dr0bnm7uja"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#00095B",
    mask: "url(#5z6dezz0nb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L64 0 64 64 0 64z",
    transform: "translate(-13 -2)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsVinNumberDocumentation);
export default __webpack_public_path__ + "static/media/icons-vin-number-documentation.122ae6a0752b747f334c82385cba8c9c.svg";
export { ForwardRef as ReactComponent };